// Calculate new font size in points based on new dimensions
export function recalculateFontSizeInPt(
  originalFontSizePt: number,
  originalWidthMM: number,
  originalHeightMM: number,
  newWidthMM: number,
  newHeightMM: number
): number {
  // Calculate scale factors for both dimensions
  const widthScaleFactor = newWidthMM / originalWidthMM;
  const heightScaleFactor = newHeightMM / originalHeightMM;

  // Use the smaller scale factor to maintain proportions
  // This prevents text from being stretched disproportionately
  const scaleFactor = Math.min(widthScaleFactor, heightScaleFactor);

  // Calculate new font size
  const newFontSizePt = Math.round(originalFontSizePt * scaleFactor);

  return scaleFactor != 1 && newFontSizePt ? newFontSizePt : originalFontSizePt;
}
